import { MdNorthWest, MdOpenInNew, MdSend, MdArrowDownward, MdArrowForward, MdKeyboardArrowDown, MdNavigateNext } from '../node_modules/react-icons/md/index.js';

const actionIndicatorToIcon = {
  MdNavigateNext,
  MdKeyboardArrowDown,
  MdArrowForward,
  MdArrowDownward,
  MdSend,
  MdOpenInNew,
  MdNorthWest
};

export { actionIndicatorToIcon };
